import Vue from 'vue'
import Router from 'vue-router'
import TopupFormView from './views/TopupFormView'
import TopupSummaryView from './views/TopupSummaryView'
import TopupBackView from './views/TopupBackView'
import { ROUTING } from './const/routing.const'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: ROUTING.stepForm,
      name: 'TopupFormView',
      component: TopupFormView
    },
    {
      path: ROUTING.stepSummary,
      name: 'TopupSummaryView',
      component: TopupSummaryView
    },
    {
      path: ROUTING.back,
      name: 'TopupBackView',
      component: TopupBackView
    },
    {
      path: '*',
      redirect: ROUTING.stepForm
    }
  ]
})
